import { Injectable } from "@angular/core";
import "rxjs/add/operator/map";
import { Http, Headers, RequestOptions } from "@angular/http";
import { environment } from "./../../../environments/environment";

@Injectable()
export class AdminService {
  constructor(private http: Http) {}

  saveWalletForAdmin(token, walletType) {
    var data;
    data = { cryptowalletselection: walletType };
    let headers = new Headers();
    headers.append("Content-Type", "application/json; charset=UTF-8");
    headers.append("authorization", token);
    return this.http
      .post(environment.serviceUrl + "admin/saveWalletForAdmin", data, {
        headers: headers,
      })
      .map((res) => res.json());
  }

  saveToken(token, tokenObj) {
    let obj = {
      data: tokenObj,
    };
    let headers = new Headers();
    headers.append("Content-Type", "application/json; charset=UTF-8");
    headers.append("authorization", token);
    return this.http
      .post(environment.serviceUrl + "admin/bulkTransfer", obj, {
        headers: headers,
      })
      .map((res) => res.json());
  }

  getAllAdminNotifications(token, pagenumber, pagesize) {
    let data = {};
    let headers = new Headers();
    headers.append("Content-Type", "application/json; charset=UTF-8");
    headers.append("authorization", token);
    return this.http
      .get(
        environment.serviceUrl +
          `admin/getAdminNotifications?pagenumber=${pagenumber}&pagesize=${pagesize}&type=all`,
        { headers: headers }
      )
      .map((res) => res.json());
  }

  changeAdminPass(token, userId, oldPass, newPass) {
    let data = { userid: userId, oldpassword: oldPass, newpassword: newPass };
    let headers = new Headers();
    headers.append("Content-Type", "application/json; charset=UTF-8");
    headers.append("authorization", token);
    return this.http
      .post(environment.serviceUrl + "admin/changePassword", data, {
        headers: headers,
      })
      .map((res) => res.json());
  }

  enableDisableNotification(token, status) {
    let data = { status: status };
    let headers = new Headers();
    headers.append("Content-Type", "application/json; charset=UTF-8");
    headers.append("authorization", token);
    return this.http
      .post(environment.serviceUrl + "admin/enableDisableNotification", data, {
        headers: headers,
      })
      .map((res) => res.json());
  }

  getAdminNotifications(token, pagenumber, pagesize) {
    let data = {};
    let headers = new Headers();
    headers.append("Content-Type", "application/json; charset=UTF-8");
    headers.append("authorization", token);
    return this.http
      .get(
        environment.serviceUrl +
          `admin/getAdminNotifications?pagenumber=${pagenumber}&pagesize=${pagesize}`,
        { headers: headers }
      )
      .map((res) => res.json());
  }

  updateAdminNotificationStatus(token, notificationid) {
    let data = {};
    let headers = new Headers();
    headers.append("Content-Type", "application/json; charset=UTF-8");
    headers.append("authorization", token);
    return this.http
      .get(
        environment.serviceUrl +
          `admin/updateNotificationStatus?notificationid=${notificationid}`,
        { headers: headers }
      )
      .map((res) => res.json());
  }

  getUserNotificationStatus(token) {
    let headers = new Headers();
    headers.append("Content-Type", "application/json; charset=UTF-8");
    headers.append("authorization", token);
    return this.http
      .get(environment.serviceUrl + `admin/getUserNotificationStatus`, {
        headers: headers,
      })
      .map((res) => res.json());
  }

  updateBlastMessage(token: string, formData: FormData) {
    let headers = new Headers();
    headers.append("authorization", token);

    return this.http
      .put(environment.serviceUrl + "admin/updateBlastMessage", formData, {
        headers: headers,
      })
      .map((res) => res.json());
  }

  updateVideo(token: string, formData: FormData) {
    let headers = new Headers();
    headers.append("authorization", token);

    return this.http
      .put(environment.serviceUrl + "admin/updateVideo", formData, {
        headers: headers,
      })
      .map((res) => res.json());
  }

  updateVideoURL(token: string, url: string) {
    let data = { url: url };
    let headers = new Headers();
    headers.append("Content-Type", "application/json; charset=UTF-8");
    headers.append("authorization", token);

    return this.http
      .put(environment.serviceUrl + "admin/updateVideoURL", data, {
        headers: headers,
      })
      .map((res) => res.json());
  }

  getPendingLiquidityRewardClaims(token: string, pageNumber: number, pageSize: number) {
    let headers = new Headers();
    headers.append("Content-Type", "application/json; charset=UTF-8");
    headers.append("authorization", token);
    headers.append("ngrok-skip-browser-warning", "true");

    return this.http
      .get(
        environment.serviceUrl +
          `admin/liquidity/pending?pageNumber=${pageNumber}&pageSize=${pageSize}`,
        { headers: headers }
      )
      .map((res) => res.json());
  }

  approveLiquidityRewardClaim(token: string, claimId: string) {
    let headers = new Headers();
    headers.append("Content-Type", "application/json; charset=UTF-8");
    headers.append("authorization", token);
    headers.append("ngrok-skip-browser-warning", "true");


    return this.http
      .post(
        environment.serviceUrl + `admin/liquidity/${claimId}/approve`,
        {},
        { headers: headers }
      )
      .map((res) => res.json());
  }

  rejectLiquidityRewardClaim(token: string, claimId: string, reason: string) {
    let data = { reason: reason };
    let headers = new Headers();
    headers.append("Content-Type", "application/json; charset=UTF-8");
    headers.append("authorization", token);
    headers.append("ngrok-skip-browser-warning", "true");

    return this.http
      .post(
        environment.serviceUrl + `admin/liquidity/${claimId}/reject`,
        data,
        { headers: headers }
      )
      .map((res) => res.json());
  }

  getPendingKYCRewards(token: string, pageNumber: number, pageSize: number) {
    let headers = new Headers();
    headers.append("Content-Type", "application/json; charset=UTF-8");
    headers.append("authorization", token);
    headers.append("ngrok-skip-browser-warning", "true");

    return this.http
      .get(
        environment.serviceUrl +
          `admin/kyc/pending?pageNumber=${pageNumber}&pageSize=${pageSize}`,
        { headers: headers }
      )
      .map((res) => res.json());
  }

  getAllKYCRewards(token: string, pageNumber: number, pageSize: number) {
    let headers = new Headers();
    headers.append("Content-Type", "application/json; charset=UTF-8");
    headers.append("authorization", token);
    headers.append("ngrok-skip-browser-warning", "true");

    return this.http
      .get(
        environment.serviceUrl +
          `admin/kyc/all?pageNumber=${pageNumber}&pageSize=${pageSize}`,
        { headers: headers }
      )
      .map((res) => res.json());
  }

  approveKYCReward(token: string, rewardId: string) {
    let headers = new Headers();
    headers.append("Content-Type", "application/json; charset=UTF-8");
    headers.append("authorization", token);
    headers.append("ngrok-skip-browser-warning", "true");

    return this.http
      .post(
        environment.serviceUrl + `admin/kyc/${rewardId}/approve`,
        {},
        { headers: headers }
      )
      .map((res) => res.json());
  }

  rejectKYCReward(token: string, rewardId: string) {
    let headers = new Headers();
    headers.append("Content-Type", "application/json; charset=UTF-8");
    headers.append("authorization", token);
    headers.append("ngrok-skip-browser-warning", "true");

    return this.http
      .post(
        environment.serviceUrl + `admin/kyc/${rewardId}/reject`,
        {},
        { headers: headers }
      )
      .map((res) => res.json());
  }
}
